import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 20px 0;
  border-top: none;
`;

export const Header = styled.div<{ impression: boolean }>`
  padding: 15px;
  background-color: white;
  color: white;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: ${(props) =>
    props.impression ? "1px solid transparent" : "1px solid #006f5e;"};
  border-top-right-radius: 30px;
  border-top-left-radius: 30px;

  h5 {
    font-size: 18px;
    color: gray;
  }

  @media (max-width: 768px) {
    h5 {
      font-size: 16px;
      display: flex;
      flex-direction: column;
    }
  }
`;

export const Body = styled.div<{ impression: boolean }>`
  display: flex;
  flex-direction: row;
  gap: 5px;
  padding: 10px 15px;
  border: ${(props) =>
    props.impression ? "1px solid transparent" : "1px solid #006f5e;"};
  border-top: none;
  border-bottom: none;
`;

export const Left = styled.div`
  width: 120%;
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const Right = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 10px 15px;
  width: 40%;
  gap: 30px;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const Line = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;
  margin: 2px 0;

  @media (max-width: 728px) {
    flex-direction: column;
  }
`;

export const Title = styled.p`
  color: black;
  font-weight: bold;
`;

export const Description = styled.p`
  color: black;
  font-weight: 500;
`;

export const DescTell = styled.a`
  color: black;
  font-weight: 500;
`;

export const ListPlan = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;

  h5 {
    color: black;
    font-size: 18px;
    font-weight: bold;
  }

  p {
    color: black;
    font-size: 16px;
  }
`;

export const ButttonHeader = styled.a`
  background-color: #006f5e;
  color: white;
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  border: 1px solid white;
  border-radius: 6px;
  padding: 8px 18px;
  cursor: pointer;

  &:hover {
    background-color: white;
    color: black;
    border: 1px solid #006f5e;
  }

  @media (max-width: 768px) {
    padding: 10px 18px;

    p {
      display: none;
    }
  }
`;

export const ButttonHeaderWaze = styled.a`
  background-color: #006f5e;
  color: white;
  display: none;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  border: 1px solid white;
  border-radius: 6px;
  padding: 8px 18px;
  cursor: pointer;

  &:hover {
    background-color: white;
    color: black;
    border: 1px solid #006f5e;
  }

  @media (max-width: 768px) {
    padding: 10px 18px;
    display: flex;
    p {
      display: none;
    }
  }
`;

export const Access = styled.div`
  display: flex;
  gap: 10px;
  justify-content: space-between;
  align-items: center;
`;

export const BarPlan = styled.div<{ impression: boolean }>`
  padding: 15px;
  background-color: white;
  gap: 10px;
  font-weight: bold;
  display: flex;
  justify-content: left;
  align-items: center;
  flex-direction: column;

  border: ${(props) =>
    props.impression ? "1px solid transparent" : "1px solid #006f5e"};

  /* Remove o topo dos itens que NÃO são o primeiro */
  &:not(:first-child) {
    border-top: none;
  }

  p {
    width: 100%;
    color: black;
    font-weight: normal;

    span {
      font-weight: bold;
    }
  }
`;

export const Distance = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;
  color: gray !important;
  font-weight: normal;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const DistanceMobile = styled.div`
  display: none;
  flex-direction: row;
  gap: 5px;
  color: white !important;
  font-weight: normal;
  margin-top: 15px;

  @media (max-width: 768px) {
    display: flex;
  }
`;

export const TitleName = styled.p`
  color: #5d5d5d;
  font-size: 24px;
  font-weight: bold;
`;

export const SocialName = styled.p`
  color: #5d5d5d;
  font-size: 18px;
`;

export const LineSiglas = styled.div`
  display: flex;
  gap: 5px;
`;

export const BadgeRedePropria = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background-color: #e8e5de;
  color: #808284;
  border: 1px solid #cfcfcd;
  border-radius: 20px;
  padding: 4px 14px;
  font-size: 13px;
  font-weight: 600;
  vertical-align: middle;
  margin-left: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
`;

export const BadgeRedeReferenciada = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background-color: #53b2e9;
  color: white;
  border: none;
  border-radius: 20px;
  padding: 4px 14px;
  height: 27px;
  font-size: 13px;
  font-weight: 600;
  vertical-align: middle;
  margin-left: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
`;

export const BadgeIconSlot = styled.span`
  display: inline-flex;
  align-items: center;
  width: 20px;
  height: 20px;
`;
